'use client';
import type { ReactElement } from 'react';
import { IconWifiOff } from '@tabler/icons-react';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Cicon } from '../Cicon';
import { Cprofileimage } from '../Cprofileimage';
import { Ctext } from '../Ctext';
interface NavbarProfileErrorActionProps {
    profileImageSize: number;
    profileImageSrc?: string;
}
export function NavbarProfileErrorAction({ profileImageSize, profileImageSrc, }: NavbarProfileErrorActionProps): ReactElement {
    return (
      <div style={{ position: 'relative', display: 'inline-flex' }}>
        <div style={{ opacity: 0.5 }}>
          <Cprofileimage dataElScope="Cpagelayout/NavbarProfileErrorAction" size={profileImageSize} borderWidth={1} borderOpacity={0.32} src={profileImageSrc} onClick={undefined} tooltip={<div style={{
                backgroundColor: '#000',
                padding: '4px 8px',
                borderRadius: '4px',
                border: '1px solid rgba(255,255,255,0.1)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                <Ctext size={10} weight={FontWeight.Medium}>
                  CABAL
                </Ctext>
                <Ctext size={10} weight={FontWeight.Medium}>
                  not reached
                </Ctext>
              </div>}/>
        </div>
        <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            pointerEvents: 'none',
            zIndex: 1,
        }}>
          <Cicon icon={IconWifiOff} color={ColorType.White} size={20}/>
        </div>
      </div>
    );
}
